// React-Screen CRebatesInfoMode ("Rabattinformation") - Strangler Phase 5,
// Klasse A. Runbook: tools/REACT-STRANGLER.md.
// Ersetzt die ESM-Huelle rebatesinfomode.js (aus
// lib/scripts/pos/components/CMP_CRebatesInfoMode.js).
// Legacy-DOM-Fixture: tests/react-fixtures/CRebatesInfoMode.html, gezogen aus
// tests/visual-baseline/23-overlay-rabattaenderungen.html.
//
// Geoeffnet ueber das Rabatt-Infoicon (CInfoIcons.showRebatesInfo), das
// CRebateEngine.checkForRebateChanges zur halben Stunde freischaltet, wenn
// Rabatte kommen oder gehen. Der Aufrufer setzt changingRebates VOR draw()
// und ruft danach drawRebatesInfo(hours, minutes).
//
// reDRAW statt reVALUE - der Unterschied ist DOM-relevant (Runbook):
// drawRebatesInfo() ruft contentText.reDraw(), und reDraw baut das Element
// ueber den Builder NEU. Anders als bei reValue() wandert der neue Wert
// deshalb AUCH ins class-Attribut, und das Element haengt sich ans ENDE des
// Elternknotens. Beides steht so in der Fixture: der contentText traegt die
// ID :4, steht aber HINTER dem backButton. In der JSX wird das abgebildet,
// indem der Absatz mit path="4" als LETZTES Kind gerendert wird - IDs kommen
// aus dem Pfad, die Reihenfolge aus der JSX.
import { defineReactScreen } from '../bridge.js';
import { CPushButton } from '../../components/pushbutton.js';

// Legacy-CCaption: innerHTML = value UND class = "CCaption <addclass> <value>".
function Caption({ bridge, path, addclass, value, style }) {
  const cls = 'CCaption' + (addclass ? ' ' + addclass : '') + ' ' + value;
  return <p {...bridge.el(path, 'CCaption')} className={cls} style={style}
            dangerouslySetInnerHTML={{ __html: value }} />;
}

function RebatesInfoModeScreen({ bridge }) {
  const t = bridge.t;
  // Legacy: okButton bleibt ein CPushButton ohne Handler, aber unsichtbar.
  const okButton = bridge.widget('7', 'CPushButton', {
    events: { onMousedown: true, onMouseout: true, onMouseup: true },
    proto: CPushButton.prototype,
  });
  // Legacy: backButton.properties.events.onMousedown = this.cancel
  const backButton = bridge.widget('8', 'CPushButton', {
    events: { onMousedown: () => bridge.cancel(), onMouseout: true, onMouseup: true },
    attributes: { onMousedown_parameter_0: bridge.id },
    proto: CPushButton.prototype,
  });

  return (
    <>
      {/* wholeOverlay */}
      <div {...bridge.el('0', 'CFrame')} className="CFrame wholeoverlay"
           style={{ position: 'absolute', visibility: 'visible' }}></div>
      {/* overlay */}
      <div {...bridge.el('1', 'CFrame')} className="CFrame overlay" style={{ position: 'absolute' }}></div>
      {/* titleBack */}
      <div {...bridge.el('2', 'CFrame')} className="CFrame titleback" style={{ position: 'absolute' }}></div>
      {/* titleText */}
      <Caption bridge={bridge} path="3" addclass="titletext" value={t('LABELS', 'REBATES_INFO_MODE')}
               style={{ fontSize: '2.0vh' }} />
      {/* priceText */}
      <Caption bridge={bridge} path="5" addclass="pricetext" value=" " />
      {/* unitsText */}
      <Caption bridge={bridge} path="6" addclass="unitstext" value=" " />
      {/* okButton */}
      <div {...okButton} className="CPushButton okbutton" style={{ visibility: 'hidden' }}>
        <Caption bridge={bridge} path="7:0" addclass="" value=" " />
      </div>
      {/* backButton */}
      <div {...backButton} className="CPushButton backbutton">
        <p {...bridge.el('8:0', 'CCaption')} className="CCaption undefined"></p>
      </div>
      {/* contentText - ZULETZT, weil Legacy ihn per reDraw() ans Ende haengt */}
      <Caption bridge={bridge} path="4" addclass="contenttext" value={bridge.state.content} />
    </>
  );
}

export const CRebatesInfoMode = defineReactScreen({
  className: 'CRebatesInfoMode',
  addclass: 'CRebatesInfoMode CashWindow',
  htmlType: 'div',
  Screen: RebatesInfoModeScreen,
  initialState: { content: ' ' },   // XML-Default aus LYT_bonOverlay.xml
  prepare(bridge) {
    bridge.Main = POS.sessions.getSessionComponent();

    // NEU (Nutzer-OK 21.8.2026), kein Legacy-Wert: der Screen war LIVE
    // UNSICHTBAR und liess sich nicht schliessen. Grund: .CashWindow setzt
    // visibility:hidden, und CRebatesInfoMode war der einzige dieser
    // Overlays, der die Sichtbarkeit nirgends zurueckholt - der
    // Nachbar-Screen CPosDisabledMode hat dafuer eine eigene CSS-Regel
    // (.CPosDisabledMode{visibility:visible} in lib/css/pos.css),
    // COnlyPayMode setzt properties.styles.visibility im prepare(). Sichtbar
    // war deshalb nur der wholeOverlay (visibility:visible inline, halb-
    // transparenter Schleier), Titel, Rabatt-Text und Abbrechen-Knopf
    // blieben unsichtbar - und ein unsichtbarer Knopf ist auch nicht
    // anklickbar (document.elementFromPoint lieferte den Schleier), der
    // Schleier blieb also bis zum Abmelden liegen. Hier derselbe Weg wie bei
    // COnlyPayMode.
    bridge.properties.styles.visibility = 'visible';
  },
  methods: {
    // Aufrufer: CInfoIcons.showRebatesInfo, direkt nach draw().
    drawRebatesInfo(bridge, hours, minutes) {
      let timeToShow;
      if (minutes >= 30)
        timeToShow = expandInteger(hours + 1, 2) + ':00';
      else
        timeToShow = expandInteger(hours, 2) + ':30';

      let someIn = false;
      let someOut = false;

      for (var i in bridge.changingRebates.rebateNames) {
        if (bridge.changingRebates.rebateEvents[i] == 'in')
          someIn = true;
        else
          someOut = true;
      }

      let text = '';

      if (someOut) {
        text += "<span style='color:#FF0000'>";

        text += bridge.t('LABELS', 'UNTIL') + '&nbsp;' + timeToShow +
          " :<div style='margin-top:5px'></div>";

        for (var i in bridge.changingRebates.rebateNames) {
          if (bridge.changingRebates.rebateEvents[i] == 'out')
            text += ' &ndash; ' + bridge.changingRebates.rebateNames[i] + '<br>';
        }

        text += '</span>';
      }

      if (someIn) {
        if (someOut)
          text += "<div style='margin-top:15px'></div>";

        text += bridge.t('LABELS', 'FROM') + '&nbsp;' + timeToShow +
          " :<div style='margin-top:5px'></div>";

        for (var i in bridge.changingRebates.rebateNames) {
          if (bridge.changingRebates.rebateEvents[i] == 'in')
            text += ' &ndash; ' + bridge.changingRebates.rebateNames[i] + '<br>';
        }
      }

      bridge.update({ content: text });
    },
    // Abbrechen-Button.
    cancel(bridge) {
      bridge.Main.InfoIcons.rebatesDataOn = false;

      bridge.removeMe();
    },
  },
});
